import { oc } from '@orpc/contract'
import { z } from 'zod'

export const projectMemberSchema = z.object({
  userId: z.string().min(1),
  email: z.string().email(),
  name: z.string().nullable(),
  avatarUrl: z.string().nullable(),
  role: z.enum(['owner', 'admin', 'member']),
  isOrgGuest: z.boolean(),
  disabledAt: z.string().nullable(),
  joinedAt: z.string(),
})

export const projectInviteSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  role: z.enum(['admin', 'member']),
  invitedBy: z.string().min(1),
  createdAt: z.string(),
  expiresAt: z.string(),
})

export const membersListContract = oc.input(z.object({ projectId: z.string().min(1) })).output(
  z.object({
    members: z.array(projectMemberSchema),
    invites: z.array(projectInviteSchema),
  })
)

export const membersInviteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      email: z.string().trim().email(),
      role: z.enum(['admin', 'member']).default('member'),
    })
  )
  .output(z.object({ status: z.enum(['added', 'invited']) }))

export const membersRevokeInviteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      inviteId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const membersRemoveContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      userId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const membersChangeRoleContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      userId: z.string().min(1),
      role: z.enum(['admin', 'member']),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const membersResendInviteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      inviteId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))

export const membersGetInviteInfoContract = oc.input(z.object({ token: z.string().min(1) })).output(
  z
    .object({
      email: z.string().email(),
      projectName: z.string(),
      inviterName: z.string().nullable(),
      expiresAt: z.string(),
    })
    .nullable()
)

export const membersToggleDisabledContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      userId: z.string().min(1),
      disabled: z.boolean(),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
